import { render, staticRenderFns } from "./A.vue?vue&type=template&id=7c9aea1a&scoped=true&"
import script from "./A.vue?vue&type=script&lang=js&"
export * from "./A.vue?vue&type=script&lang=js&"
import style0 from "./A.vue?vue&type=style&index=0&id=7c9aea1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9aea1a",
  null
  
)

export default component.exports